import { Link, useParams } from "react-router-dom";
import {
  ResultListDto,
} from "../../../Api/client/ResultClient";
import {
  Box,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  Grid,
  Heading,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Text,
  VStack,
} from "@chakra-ui/react";
import React from "react";
import { AllResultsResponse, ResultClient } from "../../../Api/client/CompetitionClient";
import ResultsView from "./ResultDisplayComponents/Results";
import { useAwaitResponse } from "../../../Api/HttpRequestHelpers";
import ResultSearchBox from "./ResultDisplayComponents/ResultSearchBox";

import { useState, useMemo } from "react";

export function capitalizeFirstLetter(name: string) {
  return name.charAt(0).toUpperCase() + name.slice(1);
}

export function BackendResultsComponent() {
  const { competitionTag } = useParams();
  
  const [allResults, isLoadingAllResults] = useAwaitResponse(
    [] as AllResultsResponse,
    () => ResultClient.getResults(competitionTag!),
    (response) => response
  );

  const [currentTabIndex, setCurrentTabIndex] = useState(0);
  const currentResults = useMemo(() => {
    return allResults[currentTabIndex]?.results || [];
  }, [currentTabIndex, allResults]);

  return (
    <>
      {/* Breadcrumb for navigation */}
      <Breadcrumb mb={8}>
        <BreadcrumbItem>
          <BreadcrumbLink as={Link} to="../../..">...</BreadcrumbLink>
        </BreadcrumbItem>

        <BreadcrumbItem>
          <BreadcrumbLink as={Link} to="..">{competitionTag}</BreadcrumbLink>
        </BreadcrumbItem>

        <BreadcrumbItem isCurrentPage>
          <BreadcrumbLink>Resultat</BreadcrumbLink>
        </BreadcrumbItem>
      </Breadcrumb>

      {/* Search box for filtering results */}
      <ResultSearchBox resultLists={currentResults} />

      {/* Chakra Tabs to display results for each competition */}
      <Tabs
        variant="enclosed"
        isLazy
        index={currentTabIndex}  // Bind the selected tab index
        onChange={(index) => setCurrentTabIndex(index)} // Update the tab index when a tab is clicked
      >
        
    <TabList p={0}>
    <Grid
      w="100%"
      templateColumns={{ base: "1fr", sm: "1fr 1fr", md: "repeat(4, 1fr)" }}
      gap={2}
    >
      {allResults.map((competitionResults) => (
        <Tab
          key={`tab_${competitionResults.competitionTag}`}
          justifyContent="center"
          w="100%"
          minH="44px"
          borderRadius="md"
          borderWidth="1px"
          borderColor="gray.200"
          _selected={{
            bg: "blue.500",
            color: "white",
            borderColor: "blue.500",
          }}
        >
          {capitalizeFirstLetter(competitionResults.competitionTag)}
        </Tab>
      ))}
    </Grid>
  </TabList>

        <TabPanels>
          {/* Tab Panels displaying results for each selected tab */}
          {allResults.map((competitionResults) => (
            <TabPanel p={0} key={`tabpanel_${competitionResults.competitionTag}`}>
              <ResultsHeader competitionTag={competitionResults.competitionTag} />

              <Box overflowX="auto">
                <ResultsView lists={competitionResults.results} />
              </Box>
            </TabPanel>
          ))}
        </TabPanels>
      </Tabs>

      {/* Information text */}
      <Text marginTop={"30px"} fontWeight={"black"} color={"gray.500"} fontSize={"12px"}>
        Varför visas inte resultaten för de yngre deltagarna?
      </Text>
      <Text
        textStyle={"italic"}
        marginLeft={"10px"}
        color={"gray.500"}
        fontSize={"12px"}
      >
        Svenska Friidrottsförbundet beslutade 2020 att resultat för barn upp
        till 11 år inte får publiceras öppet på internet. För att följa dessa
        riktlinjer visar vi resultaten i ett dolt format - du behöver klicka för
        att se dem. På så sätt gör vi informationen tillgänglig utan att bryta
        mot förbundets bestämmelser.
      </Text>
    </>
  );
}

/*
function DefaultTable({
  resultLists,
}: {
  resultLists: Array<ResultListDto<ResultDto>>;
}) {
  const isMobile = useBreakpointValue({ base: true, md: false });
  return (
    <Table size="xs" variant="striped">
      <Tbody>
        {resultLists.map((resultList, listIndex) => {
          const sorted = resultList.results
            .filter((r) => r.startTime != null && r.finishTime != null)
            .sort((a, b) => {
              const sortOnResults = resultList.showResults;
              if (sortOnResults) {
                const aTime = rTime(a);
                const bTime = rTime(b);
                return aTime - bTime;
              } else {
                return [a.firstname, a.lastname]
                  .join("")
                  .localeCompare([b.firstname, b.lastname].join(""));
              }
            });

          return (
            <React.Fragment key={resultList.name}>
              <Tr>
                <Th
                  colSpan={isMobile ? 3 : 5}
                  background={"white"}
                  height={"100px"}
                ></Th>
              </Tr>
              <Tr>
                <Th colSpan={isMobile ? 3 : 5} background={"blue.100"}>
                  <Center>
                    <Heading
                      marginTop={"10px"}
                      size={"md"}
                      fontFamily={"monospace"}
                    >
                      {resultList.name}
                    </Heading>
                  </Center>
                </Th>
              </Tr>
              <Tr>
                <Th padding={0} paddingLeft={"5px"} textAlign={"center"}>
                  Plats
                </Th>
                <Th textAlign={"center"}>Tid</Th>
                <Th>Deltagare</Th>
                {isMobile || <Th>Nr</Th>}
                {isMobile || <Th>Klubb/Lag</Th>}
              </Tr>

              {sorted.map((r, i) => (
                <ResultRow
                  key={r.id}
                  index={i}
                  result={r}
                  showResults={resultList.showResults}
                />
              ))}
            </React.Fragment>
          );
        })}
      </Tbody>
    </Table>
  );
}
*/

/*
export function ResultRow({
  result,
  index,
  showResults,
}: {
  result: ResultDto;
  index: number;
  showResults: boolean;
}) {
  const [isHovered, setIsHovered] = useState(false);
  const timeVisible = showResults || isHovered;
  const isMobile = useBreakpointValue({ base: true, md: false });

  return (
    <Tr
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      _hover={{ transform: "scale(1.02)", background: "gray.50" }}
      transition="transform 0.15s ease-in-out"
    >
      <Td padding={0} textAlign={"center"} fontWeight={"black"}>
        {showResults ? index + 1 : "-"}
      </Td>
      <Td textAlign="center" fontWeight={"black"}>
        <Box opacity={timeVisible ? 1 : 0} transition="opacity 0.2s">
          {formatTime(rTime(result))}
        </Box>
      </Td>
      <Td>
        {result.firstname} {result.lastname}{" "}
        {isMobile ? `${result.clubOrTeam ? `(${result.clubOrTeam})` : ""}` : ""}
      </Td>
      {isMobile || <Td>{result.startnumber}</Td>}
      {isMobile || <Td>{result.clubOrTeam ?? "—"}</Td>}
    </Tr>
  );
}

function rTime(r: ResultDto): number {
  return r.finishTime! - r.startTime!;
}

function formatTime(ms: number): string {
  const totalSeconds = Math.floor(ms / 1000);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  if (hours > 0) {
    return `${hours}:${minutes.toString().padStart(2, "0")}:${seconds
      .toString()
      .padStart(2, "0")}`;
  } else {
    return `${minutes}:${seconds.toString().padStart(2, "0")}`;
  }
}
*/

function ResultsHeader(props: { competitionTag: string | undefined }) {
  return (
    <VStack marginTop={"50px"} spacing={4} align="start" w="100%" mb={6}>
      <Box>
        <Heading size="md" mb={2}>
          {`Resulat för ${props.competitionTag}`}
        </Heading>
      </Box>

{/** 
      <Button
        colorScheme="blue"
        onClick={() => {
          window.location.reload();
        }}
        leftIcon={<Icon as={RefreshCcw} />} // Adding the Lucide refresh icon
      >
        Ladda om sidan
      </Button>
*/}
    </VStack>
  );
}
